import axios from './index';

/** 类型：32 空投 33 其他加线 34 其他扣线 */
export type CapitalOperationType = 32 | 33 | 34;

export interface CapitalOperationRecord {
    id: string;
    user_id: string;
    type: CapitalOperationType;
    token: string;
    amount: string;
    reason: string;
    status: 'Init' | 'Success' | 'Failure';
    created_at: string;
    updated_at: string;
    deleted_at?: string | null;
    version?: string;
}

export interface CapitalOperationRecordCreatePayload {
    user_id: string;
    type: CapitalOperationType;
    token: string;
    amount: string | number;
    reason: string;
}

export interface CapitalOperationListParams {
    page?: number;
    size?: number;
    start_time?: string;
}

export interface PageMeta {
    page?: number;
    size?: number;
    total?: number;
    cursor?: string;
    more?: boolean;
}

export interface ResList<T> {
    code: number;
    data: T[];
    msg: string;
    meta?: PageMeta;
}

export interface ResOne<T> {
    code: number;
    data: T;
    msg: string;
}

export const capitalOperationRecordsList = (params: CapitalOperationListParams) =>
    axios<ResList<CapitalOperationRecord>>('/v1/capital-operation-records', {
        method: 'get',
        params,
    });

export const capitalOperationRecordsCreate = (data: CapitalOperationRecordCreatePayload) =>
    axios<ResOne<CapitalOperationRecord>>('/v1/capital-operation-records', {
        method: 'post',
        data: {
            ...data,
            amount: String(data.amount),
        },
    });

export const capitalOperationRecordsDetail = (id: string) =>
    axios<ResOne<CapitalOperationRecord>>(`/v1/capital-operation-records/${id}`, {
        method: 'get',
    });
